/**
 * Checkout cancel page.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function BillingCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="billing-cancel-page">
      <div className="max-w-lg w-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 space-y-4">
        <div className="text-xs uppercase tracking-widest text-white/50">Billing</div>
        <h1 className="text-2xl font-semibold text-white" data-testid="billing-cancel-heading">
          Checkout canceled
        </h1>
        <p className="text-white/70 text-sm">
          No charge was made. You can restart the checkout at any time.
        </p>
        <div className="pt-2">
          <Link to="/institution/billing">
            <Button data-testid="billing-cancel-back">Back to Billing</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
